import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { usePopupFailure } from '../../contexts/PopupFailureContext';

export default function PmsSchedulingStatus({ scope }) {
    // A failed settings load (not the access-denied state) can be pinned.
    const { report } = usePopupFailure();
    const loadFailed = Boolean(scope.error && !scope.denied);
    useEffect(() => {
        if (loadFailed) report('Booking settings could not be loaded.', 'Booking settings');
    }, [loadFailed]); // eslint-disable-line react-hooks/exhaustive-deps
    return scope.error ? <Alert severity="error" action={<Button onClick={scope.retry}>Retry</Button>}>
        {scope.denied ? 'You do not have access to native booking for this practice.' : 'Booking settings could not be loaded. Retry before starting a booking.'}
    </Alert> : <Stack sx={{ p: 2 }} role="status"><Typography>Loading booking settings…</Typography></Stack>;
}
PmsSchedulingStatus.propTypes = { scope: PropTypes.shape({ error: PropTypes.bool, denied: PropTypes.bool, retry: PropTypes.func }).isRequired };
